import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10.172 7.703a2.098 2.098 0 0 0-2.944 0 2.03 2.03 0 0 0 0 2.894 2.098 2.098 0 0 0 2.944 0 2.03 2.03 0 0 0 0-2.894Zm-3.929-.995a3.498 3.498 0 0 1 4.914 0 3.43 3.43 0 0 1 0 4.884 3.498 3.498 0 0 1-4.914 0 3.43 3.43 0 0 1 0-4.884ZM17.22 7.981a1.3 1.3 0 1 0-1.838 1.838 1.3 1.3 0 0 0 1.838-1.838l.483-.483-.483.483Zm-2.828-.99a2.7 2.7 0 0 1 3.818 0l-.495.495.495-.495a2.7 2.7 0 1 1-3.818 0Zm.209 6.288a.7.7 0 0 1 .7-.7h3a2.7 2.7 0 0 1 2.7 2.7v.5a.7.7 0 1 1-1.4 0v-.5a1.3 1.3 0 0 0-1.3-1.3h-3a.7.7 0 0 1-.7-.7ZM5.922 15c-.847 0-1.522.678-1.522 1.5v1.1a.7.7 0 1 1-1.4 0v-1.1c0-1.608 1.315-2.9 2.922-2.9h5.556c1.607 0 2.922 1.292 2.922 2.9v1.1a.7.7 0 1 1-1.4 0v-1.1c0-.822-.675-1.5-1.522-1.5H5.922Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
